import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-keep',
    templateUrl: './keep.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeepComponent {

}
